import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import {DialogAncestor} from "core/common/page/dialogAncestor";
import {action} from "mobx";
import {observer} from "mobx-react";
import {loc} from "core/common/config/locales";

interface ConfirmationDialogProps {
  cancelButtonText?: string;
  okButtonText?: string;
  title?: string;
  contentComponent?: any;
}

interface ConfirmationDialogState {
  title?: string;
}


/**
 * title muze byt nedefinovany - pak se pouzije z defaultniho state, nebo prijit pres props, nebo projit z open (nejvyssi priorita)
 */
@observer
export default class ConfirmationDialog extends DialogAncestor<ConfirmationDialogProps, ConfirmationDialogState, string> {


  static defaultProps = {
    cancelButtonText: loc.i18n`No, return back`,
    okButtonText: loc.i18n`Yes, continue`
  };

  state = {
    title: loc.i18n`You have unsaved information, are you sure you want to leave this page?`
  };


  @action open(resolve, reject, title?: string) {
    console.log('ConfirmationDialog: Opening confirmation dialog');
    this.resolve = resolve;
    this.reject = reject;
    this.dialogOpen = true;
    this.setState({
      title: (title) ? title : ( (this.props.title) ? this.props.title : this.state.title )
    });
  }

  @action ok = () => {
    console.log('ConfirmationDialog OK');
    this.dialogOpen = false;
    this.resolve("ok");
  };

  @action cancel = () => {
    console.log('ConfirmationDialog CANCEL');
    this.dialogOpen = false;
    this.reject("cancel");
  };


  render() {
    let {cancelButtonText, okButtonText, contentComponent} = this.props;

    const actions = [
      <FlatButton
        label={cancelButtonText}
        primary
        onClick={this.cancel}
      />,
      <FlatButton
        label={okButtonText}
        secondary
        onClick={this.ok}
      />,
    ];

    return (
      <Dialog
        title={this.state.title}
        actions={actions}
        modal={true}
        open={this.dialogOpen}
        contentStyle={{width: 450, zIndex: 3000}}>

        {contentComponent}

      </Dialog>
    );
  }


}



// WEBPACK FOOTER //
// ./src/core/components/confirmationDialog/confirmationDialog.tsx